import { Route as rootRoute } from './routes/__root';
import { Route as IndexRoute } from './routes/index';
import { Route as LoginRoute } from './routes/login';
import { Route as DashboardRoute } from './routes/dashboard';
import { Route as SettingsRoute } from './routes/settings';
import { Route as GuideRoute } from './routes/guide';
import { Route as AdminRoute } from './routes/admin';
import { Route as InventoryIndexRoute } from './routes/inventory/index';
import { Route as InventoryNewRoute } from './routes/inventory/new';
import { Route as InventoryBatchRoute } from './routes/inventory/batch';
import { Route as InventoryItemIdRoute } from './routes/inventory/$itemId';
import { Route as LibraryRoute } from './routes/library';
import { Route as HealthRoute } from './routes/health';
import { Route as ShowroomRoute } from './routes/showroom';
import { Route as AboutRoute } from './routes/about';
import { Route as TermsRoute } from './routes/terms';
import { Route as PrivacyRoute } from './routes/privacy';
import { Route as ProfileSlugRoute } from './routes/profile.$slug';
import { Route as WantedRoute } from './routes/wanted';
import { Route as OffersRoute } from './routes/offers';
import { Route as OfferDetailRoute } from './routes/offers.$offerId';
import { Route as StatsRoute } from './routes/stats';
import { Route as ActivityRoute } from './routes/activity';
import { Route as MessagesRoute } from './routes/messages';
import { Route as DuplicatesRoute } from './routes/duplicates';
import { Route as SetsRoute } from './routes/sets';
import { Route as SetDetailRoute } from './routes/sets.$setId';
import { Route as DownloadRoute } from './routes/download';
import { Route as DownloadSuccessRoute } from './routes/download-success';
import { Route as PricingRoute } from './routes/pricing';
import { Route as UpgradeRoute } from './routes/upgrade';
import { Route as RefundRoute } from './routes/refund';
import { Route as VaultsRoute } from './routes/vaults';
import { Route as VaultsCustomRoute } from './routes/vaults.custom';
import { Route as VaultsSettingsRoute } from './routes/vaults.settings';
import { Route as FeedbackRoute } from './routes/feedback';

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  LoginRoute,
  DashboardRoute,
  SettingsRoute,
  GuideRoute,
  AdminRoute,
  InventoryIndexRoute,
  InventoryNewRoute,
  InventoryBatchRoute,
  InventoryItemIdRoute,
  LibraryRoute,
  HealthRoute,
  ShowroomRoute,
  AboutRoute,
  TermsRoute,
  PrivacyRoute,
  ProfileSlugRoute,
  WantedRoute,
  OffersRoute,
  OfferDetailRoute,
  StatsRoute,
  ActivityRoute,
  MessagesRoute,
  DuplicatesRoute,
  SetsRoute,
  SetDetailRoute,
  DownloadRoute,
  DownloadSuccessRoute,
  PricingRoute,
  UpgradeRoute,
  RefundRoute,
  VaultsRoute,
  VaultsCustomRoute,
  VaultsSettingsRoute,
  FeedbackRoute,
]);
